import React, { useMemo } from 'react';

import { AiProvider } from '@kp/react-ai';
import { useAuth } from '@kp/react-sdk';

import { LLM_URI } from '@/utils/env';

const LLM_MODEL = 'small/Qwen3.6-27B';

const SYSTEM_PROMPTS = [
  'You are the Brix2Bytes Portal assistant for Kieback&Peter building operators.',
  'For data questions you MUST use the provided tools and answer only from their results. Never invent data values. For general messages, answer directly.',
  'When a question refers to a building or space by name, first list the spaces to find the matching one, then pass its id and type to the data tools.',
  'If no tool can answer a data question, say so plainly instead of guessing.',
];

interface AiChatProviderProps {
  children?: React.ReactNode;
}

export const AiChatProvider: React.FC<AiChatProviderProps> = ({ children }) => {
  const { user } = useAuth();
  const token = user?.access_token ?? '';

  const config = useMemo(
    () => ({
      endpoint: LLM_URI,
      model: LLM_MODEL,
      token,
      systemPrompts: SYSTEM_PROMPTS,
    }),
    [token],
  );

  return <AiProvider config={config}>{children}</AiProvider>;
};
